import { DataBlock, DynamicValue } from "@/core/datablocks/types/blocks";
import { ContentType, DataTemplate } from "@/core/datablocks/types/templates";
import { useDataBlockRelatedData } from "@/core/datablocks/hooks/useDataBlockRelatedData";
import { BaseUser } from "@/views/profiles/types/user";
import {
  formatDataBlockValueByType,
  getDataBlockFieldValue,
  useDataBlockField,
} from "@/core/datablocks/hooks/useDataBlockField";

export function getDataBlockTitle(
  dataBlock: DataBlock | undefined,
): string | undefined {
  return getDataBlockFieldValue<string>(dataBlock, "title");
}

export function getDataBlockContributors(
  dataBlock: DataBlock | undefined,
): number[] {
  return getDataBlockFieldValue<number[]>(dataBlock, "contributors") || [];
}

export function getDataBlockLanguages(
  dataBlock: DataBlock | undefined,
  template: DataTemplate | undefined,
): string[] | undefined {
  const rawLanguages = getDataBlockFieldValue(dataBlock, "languages");
  const languagesField = template?.templateFields.find(
    (tf) => tf.id === dataBlock?.fieldsMapping.languages,
  );

  if (!languagesField) return undefined;
  return formatDataBlockValueByType(
    rawLanguages as DynamicValue,
    languagesField,
  ) as string[];
}

export function useDataBlockContributors(
  dataBlock: DataBlock | undefined,
  options?: { rawValue?: boolean },
) {
  const contributorIds = useDataBlockField(
    dataBlock,
    "contributors",
    undefined,
    { rawValue: true },
  ) as number[] | undefined;

  const { data: contributors, isLoading } = useDataBlockRelatedData(
    contributorIds || [],
    ContentType.Users,
  ) as { data: BaseUser[] | undefined; isLoading: boolean };

  return {
    data: (options?.rawValue ? contributorIds : contributors) || [],
    isLoading,
  };
}
